export const certificateEn = {
    xunjiadang:'Certificate management',
    zhengshuzhuantai:'Doc Status',
    quanxuan:'All',
    wuxiao:'invalid',
    youxiao:'Effective',
    kaishishijian:'start time',
    jieshushijian:'End time',
    zhengshubianhao:'Certificate number',
    zhengshumingcheng:'Certificate name',
    sousuo:'search',
    xuhao:'Serial number',
    youxiaoqi:'Term of validity',
    daoqishijian:'Due time',
    caozuo:'operation'
}


// WEBPACK FOOTER //
// ./src/lang/member/certificate/certificateEn.js